import httpClient from 'shared/lib/httpClient';
import { parseMenuList } from '../schemas/MasterDataSchema';

export const getMenuList = async () => {
  const response = await httpClient.get('/menus');
  return parseMenuList(response?.data);
};
